import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Home, MessageCircle, History, Compass, Menu} from "lucide-react";

function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`bg-[#1E1E24] ${isOpen ? "w-64" : "w-20"} h-screen flex flex-col p-4 transition-all`}>
      <button onClick={() => setIsOpen(!isOpen)} className="text-white mb-6">
        <Menu size={24} />
      </button>

      <nav className="space-y-4">
        <Link to="/" className="flex items-center text-gray-300 hover:text-white p-2 rounded-lg hover:bg-[#292933] transition">
          <Home className="mr-3" size={20} /> {isOpen && "Home"}
        </Link>
        
        <Link to="secpage.jsx" className="flex items-center text-gray-300 hover:text-white p-2 rounded-lg hover:bg-[#292933] transition">
          <Compass className="mr-3" size={20} /> {isOpen && "Problems"}
        </Link>

        {/* <Link to="/practice" className="flex items-center text-gray-300 hover:text-white p-2 rounded-lg hover:bg-[#292933] transition">
          <Menu className="mr-3" size={20} /> {isOpen && "Practice"}
        </Link> */}

        {/* <Link to="/leaderboard" className="flex items-center text-gray-300 hover:text-white p-2 rounded-lg hover:bg-[#292933] transition">
          <LucideAArrowUp className="mr-3" size={20} /> {isOpen && "AI Coach"}
        </Link> */}

        <Link to="/chat" className="flex items-center text-gray-300 hover:text-white p-2 rounded-lg hover:bg-[#292933] transition">
          <MessageCircle className="mr-3" size={20} /> {isOpen && "AI Coach"}
        </Link>

        <Link to="/profile" className="flex items-center text-gray-300 hover:text-white p-2 rounded-lg hover:bg-[#292933] transition">
          <History className="mr-3" size={20} /> {isOpen && "Progress"}
        </Link>
      </nav>
    </div>
  );
}

export default Sidebar;
